/**
 * Settings & Pipeline Page Hints
 *
 * Contextual hints for the business portal settings and pipeline pages.
 * Routes must match the actual page where the `data-astor-id` element lives.
 */

import type { HintConfig } from './hint-config.types';

export const settingsPipelineHints: HintConfig[] = [
  {
    id: 'settings-astor-agents',
    targetAstorId: 'settings-astor-agents',
    title: 'hints.settings.astorAgents.title',
    description: 'hints.settings.astorAgents.description',
    portal: 'business',
    route: '/control-center/astor-agents',
    showOnce: true,
    priority: 'high',
    variant: 'tip',
    placement: 'bottom',
  },
  {
    id: 'settings-team-management',
    targetAstorId: 'settings-team-management',
    title: 'hints.settings.team.title',
    description: 'hints.settings.team.description',
    portal: 'business',
    route: '/team/members',
    showOnce: true,
    priority: 'medium',
    variant: 'info',
    placement: 'right',
  },
  {
    id: 'settings-notifications',
    targetAstorId: 'settings-notifications',
    title: 'hints.settings.notifications.title',
    description: 'hints.settings.notifications.description',
    portal: 'business',
    route: '/notifications',
    showOnce: true,
    priority: 'low',
    variant: 'info',
    placement: 'right',
  },
];
